<template>
	<!-- <div v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="10"> -->
	<div>
		<el-row class="toolbar">
			<el-button type="primary" :style="this.responsive.isMobile ? 'margin: 10px' : 'primary'" @click="agregarAlCarrito" :loading="loadingCart"
				>Agregar<i class="el-icon-shopping-cart-2"></i
			></el-button>
		</el-row>
		<div style="height: 1000px; overflow-y: auto; overflow-x: none;">
			<el-table :data="products" style="width: 100%;">
				<el-table-column label="Imagen" width="100">
					<template slot-scope="scope">
						<el-image
							class="pic"
							:src="'./api/public/proxy/files?&cooperativa=' + cooperativa + '&type=pedidos&archivo=' + scope.row.url[0]"
							fit="contain"
						>
							<div slot="placeholder" class="pic slot">
								Cargando...
							</div>
							<div slot="error" class="pic slot">SIN FOTO</div>
						</el-image>
					</template>
				</el-table-column>
				<el-table-column prop="nombre" label="Producto" :min-width="this.responsive.isMobile ? 100 : 130"></el-table-column>
				<el-table-column v-if="!this.responsive.isMobile" prop="codigo_alfanumerico" label="Código" min-width="90"></el-table-column>
				<!-- <el-table-column prop="codart" label="EAN" width="120"></el-table-column> -->
				<el-table-column label="Cantidad" width="90">
					<template slot-scope="scope">
						<el-input v-model="scope.row.cant" @input="updateTotals(scope.row)" />
					</template>
				</el-table-column>
				<el-table-column prop="precio_lista_con_formato" label="Precio" :min-width="this.responsive.isMobile ? 100 : 140">
					<template slot-scope="scope">
						<span>{{ formatCurrency(scope.row.precio_lista) }}</span>
					</template>
				</el-table-column>
				<el-table-column v-if="!this.responsive.isMobile" label="Sub total" :min-width="this.responsive.isMobile ? 100 : 140">
					<template slot-scope="scope">
						<span>{{ formatCurrency(scope.row.subtotal) }}</span>
					</template>
				</el-table-column>
				<el-table-column
					v-if="!this.responsive.isMobile"
					prop="bonificacion_uno_con_formato"
					label="Desc 1(%)"
					min-width="100"
				></el-table-column>
				<el-table-column
					v-if="!this.responsive.isMobile"
					prop="bonificacion_dos_con_formato"
					label="Desc 2(%)"
					min-width="100"
				></el-table-column>

				<el-table-column v-if="!this.responsive.isMobile" label="P.Unit c/Desc" min-width="140">
					<template slot-scope="scope">
						<span>{{ formatCurrency(scope.row.precioUnitarioDescuento) }}</span>
					</template>
				</el-table-column>
				<el-table-column :label="this.responsive.isMobile ? 'Total' : 'Total c/Desc'" min-width="140">
					<template slot-scope="scope">
						<span>{{ formatCurrency(scope.row.totalConDescuento) }}</span>
					</template>
				</el-table-column>
			</el-table>
			<div v-if="products.length > 0">
				<div slot="footer" class="text-center" v-if="showBtnMore">
					<!--v-observe-visibility="loadMore"-->
					<el-button type="text" ref="loadMore" size="mini" @click="loadMoreClick" :loading="loading"
						>{{ loading ? 'Cargando...' : 'Mostrar más productos' }}<i class="el-icon-caret-bottom"></i
					></el-button>
				</div>
			</div>
			<div slot="footer" class="text-center" v-if="!showBtnMore">
				<p style="font-size: 12px; color: #969799;">No hay más registros.</p>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	inject: ['responsive'],
	data() {
		return {
			loading: false,
			loadingCart: false,
			showBtnMore: false, // Control de la paginación o lote de datos
		};
	},
	computed: {
		products() {
			return this.$store.state.pedidos.allproductos;
		},
		idcarrito() {
			return this.$store.state.pedidos.idcarrito;
		},
		total() {
			return this.$store.state.pedidos.total;
		},
		filter() {
			return this.$store.state.pedidos.filter;
		},
		allstart() {
			return this.$store.state.pedidos.allstart;
		},
		alllimit() {
			return this.$store.state.pedidos.alllimit;
		},
		allpage() {
			return this.$store.state.pedidos.alllimit;
		},
		cooperativa() {
			return this.$store.state.config.cuit;
		},
	},
	watch: {
		products(products) {
			this.total > parseInt(products.length) ? (this.showBtnMore = true) : (this.showBtnMore = false);
		},
	},

	methods: {
		updateTotals(product) {
			product.subtotal = product.cant * product.precio_lista;
			product.totalConDescuento = product.cant * product.precio_lista * (1 - parseFloat(product.bonificacion_uno) / 100);
			product.precioUnitarioDescuento = product.precio_lista * (1 - parseFloat(product.bonificacion_uno) / 100);
		},
		agregarAlCarrito() {
			this.loadingCart = true;
			// Filtra los productos con cantidad mayor a cero
			const productosConCantidad = this.products.filter(product => product.cant > 0);

			if (productosConCantidad.length === 0) {
				this.$message.warning('No hay productos con cantidad seleccionada');
				return;
			}

			// Establece el estado de carga
			//this.loading = true;

			// Itera sobre los productos con cantidad mayor a cero y los agrega al carrito
			Promise.all(
				productosConCantidad.map(producto => {
					// Despachar la acción para agregar el producto al carrito
					producto.pedido_id = this.idcarrito;
					producto.pedido_cantidad = producto.cant;
					return this.$store.dispatch('addProducto', producto);
				})
			)
				.then(() => {
					//this.$store.dispatch('loadAllProductos');
					/*this.$store.dispatch('resetAllProductos').then(() => {
						this.$store.dispatch('loadAllProductos');
					});*/
					this.products.map(producto => {
						producto.cant = null;
					});
					this.$message.success('Productos agregados al carrito con éxito');
				})
				.catch(error => {
					this.$message.error('Error al agregar productos al carrito: ' + error);
				})
				.finally(() => {
					// Restablece el estado de carga
					//this.loading = false;
					this.loadingCart = false;
				});
		},
		formatCurrency(value) {
			// Asegúrate de que el valor sea un número
			if (typeof value !== 'number') value = parseFloat(value);
			if (isNaN(value)) return '$ 0,00'; // Valor por defecto si no es un número válido

			// Forzar siempre dos decimales y usar un formato adecuado con punto para miles y coma para decimales
			return (
				'$ ' +
				value
					.toFixed(2) // Asegura 2 decimales
					.replace(/\B(?=(\d{3})+(?!\d))/g, '.') // Coloca puntos como separador de miles
					.replace(/.(\d{2})$/, ',$1')
			); // Mantiene la coma como separador decimal
		},
		// loadMore() {
		// 	let start = this.allstart + this.alllimit;
		// 	//let page = this.allpage + 1;
		// 	this.$store.dispatch('loadAllStart', start);
		// 	//this.$store.dispatch('loadAllPage', page);
		// 	this.$store.dispatch('loadAllProductos').then(() => {});
		// },
		loadMoreClick() {
			let start = this.allstart + this.alllimit;
			//let page = this.allpage + 1;
			this.$store.dispatch('loadAllStart', start);
			this.$store.dispatch('loadAllProductos').then(() => {});
		},
	},
	mounted() {
		this.$store.dispatch('loadAllProductos');
	},
};
</script>

<style scoped>
.toolbar {
	display: flex;
	justify-content: flex-end; /* Alinea el contenido (botón) a la derecha */
	margin-bottom: 20px;
}
.pic {
	min-width: 60px;
	width: 80px;
	height: 60px;
	vertical-align: top;
}
.pic.slot {
	display: flex;
	justify-content: center;
	align-items: center;
	background-color: #efefef;
	font-size: 12px;
}
</style>
